import { type ApiMetadata } from '@webapp/core/interfaces/api/ApiMetadata'
import { type ApiPagination } from '@webapp/core/interfaces/api/ApiPagination'
import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { formatRepoFiltersToApiFilters } from '@webapp/core/utils/repositories/formatRepoFiltersToApiFilters'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type TravelTicketOptionConstructor } from '@webapp/modules/expense/entities/TravelTicketOption'
import { type ITravelTicketRepository } from '../../../business-logic/interfaces/ITravelTicketRepository'
import { type TravelTicketOptionApiModel } from '../../api-models/TravelTicketOptionApiModel'
import { mapTravelTicketOptionApiModel } from '../../mappers/mapTravelTicketOptionApiModel'

interface Dependency {
  httpClient: IHttpClient
}

export class TravelTicketRepository implements ITravelTicketRepository {
  constructor(private readonly deps: Dependency) {}

  async listAttachable(
    params: { userId: number } & RepoFilterParams
  ): Promise<RepoPaginatedResponse<TravelTicketOptionConstructor>> {
    const { userId, ...filterParams } = params

    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<TravelTicketOptionApiModel[], ApiMetadata<ApiPagination>>
      >(`/api/v3/travels/`, {
        params: {
          attachable: userId,
          ...formatRepoFiltersToApiFilters(filterParams),
        },
      })

      const metadata = res.data.metadata

      return {
        data: res.data.data.map(mapTravelTicketOptionApiModel),
        pagination: {
          count: metadata?.pagination?.count || 0,
          page: metadata?.pagination?.current_page || 0,
          pageSize: metadata?.pagination?.page_size || 0,
          numPages: metadata?.pagination?.num_pages || 0,
        },
      }
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
